import { useEffect } from 'react';
export default function useBlurDetector(ref, dialog, closeDialog) {
	let paused = false;
	useEffect(() => {
		const focusOutHandler = e => {
			if (!paused && ref.current && !dialog?.current?.$el?.classList.contains('hidden')) {
				if (
					!e.relatedTarget ||
					(!ref.current.isSameNode(e.relatedTarget) && !ref.current.contains(e.relatedTarget))
				) {
					closeDialog();
					if (e.relatedTarget) {
						e.relatedTarget?.focus();
					}
				}
			}
		};
		const field = ref?.current;
		field?.addEventListener('focusout', focusOutHandler);
		return () => {
			field?.removeEventListener('focusout', focusOutHandler);
		};
	});
	return { pause: () => (paused = true), resume: () => (paused = false) };
}
